import React, { ReactNode } from 'react';

import { Alert } from 'react-bootstrap';
import styled from 'styled-components';

const StyledAlert = styled(Alert)<{ show: boolean }>`
  position: fixed;
  top: ${props => (props.show ? '0' : '-1000px')};
  left: 0;
  right: 0;
  z-index: 9999;
  margin: auto;
  width: 100%;
  padding: 9px 6px;
  background: #46a5c8;
  text-align: center;
  a {
    display: block;
    color: #fff;
    text-decoration: none;
    margin-bottom: 10px;
  }

  button {
    margin: auto;
  }

  transition: top 1.5s;

  .close {
    top: 0px;
    right: 0;
    color: #000;
    opacity: 0.5;
  }

  p {
    color: #fff;
  }
`;

type AlertWrapperProps = {
  show: boolean;
  onDismiss?: () => void;
  children: ReactNode;
};

const AlertWrapper = ({ show, onDismiss, children }: AlertWrapperProps) => {
  return (
    <StyledAlert show={show} onDismiss={onDismiss}>
      {children}
    </StyledAlert>
  );
};

export default AlertWrapper;
